import React from 'react';
import styled from 'styled-components';
import { IconTime } from '../../Atoms/Icon';
import { P4 } from '../../Atoms/Typo';

const Component = styled.div`
  display: flex;
  align-items: center;
  height: 17px;

  div {
    ${P4}
    color: ${(props) => props.theme.colors.grey300};
  }
  svg {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    path {
      fill: ${(props) => props.theme.colors.grey300};
    }
  }
`;

interface TimerProps {
  time: string;
}

const Timer = ({ time }: TimerProps) => {
  return (
    <Component className="voda_timer">
      <IconTime />
      <div>{time}</div>
      <div>초 후 로그인 만료</div>
    </Component>
  );
};

export default Timer;
